@if ((uploads$ | async)?.length && !isHidden) {
  <div class="upload-progress-container" [class.minimized]="isMinimized">
    <div class="header">
      <div class="header-content">
        <div class="title">
          @if (activeUploadsCount > 0) {
            <span class="upload-text"
              >Uploading {{ activeUploadsCount }} item{{
                activeUploadsCount > 1 ? "s" : ""
              }}</span
            >
          } @else {
            <span class="complete-text">
              Uploads complete
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="check-icon"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </span>
          }
        </div>
      </div>
      <div class="actions">
        <button
          class="minimize-btn"
          (click)="
            activeUploadsCount > 0 ? minimizeToHeader() : closeUploadProgress();
            $event.stopPropagation()
          "
          [title]="activeUploadsCount > 0 ? 'Minimize' : 'Close'"
        >
          @if (activeUploadsCount > 0) {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          } @else {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          }
        </button>
      </div>
    </div>

    <div class="upload-list">
      @for (item of uploads$ | async; track item.id) {
        <div
          class="upload-item"
          [class.completed]="item.status === 'completed'"
          [class.failed]="item.status === 'failed'"
        >
          <div class="file-icon-wrapper">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="file-icon"
            >
              <path
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
              ></path>
              <polyline points="14 2 14 8 20 8"></polyline>
            </svg>
          </div>
          <div
            class="file-info"
            [class.completed]="item.status === 'completed'"
          >
            <div class="file-header">
              <div class="file-name" [title]="item.fileName || item.file?.name">
                {{ item.fileName || item.file?.name }}
              </div>
              @if (item.status === "uploading") {
                <button
                  class="cancel-btn"
                  (click)="cancelUpload(item.id)"
                  title="Cancel upload"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              }
            </div>
            @if (item.status === "uploading") {
              <div class="progress-bar-container">
                <div class="progress-bar" [style.width.%]="item.progress"></div>
              </div>
              <div class="progress-text">{{ item.progress }}%</div>
            } @else if (item.status === "completed") {
              <div class="status-message success">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 640 640"
                  fill="#059669"
                  class="status-icon"
                >
                  <path
                    d="M320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576zM438 209.7C427.3 201.9 412.3 204.3 404.5 215L285.1 379.2L233 327.1C223.6 317.7 208.4 317.7 199.1 327.1C189.8 336.5 189.7 351.7 199.1 361L271.1 433C276.1 438 282.9 440.5 289.9 440C296.9 439.5 303.3 435.9 307.4 430.2L443.3 243.2C451.1 232.5 448.7 217.5 438 209.7z"
                  />
                </svg>
              </div>
            } @else if (item.status === "failed") {
              <div class="status-message error">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="status-icon"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                Upload failed
              </div>
            } @else if (item.status === "cancelled") {
              <div class="status-message cancelled">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="status-icon"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
                Upload cancelled
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
